/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
import '../../common/currency';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "client": {
        "nested": {
          "devicesettings": {
            "nested": {
              "DeviceProfile": {
                "nested": {
                  "Settings": {
                    "fields": {
                      "cashManagement": {
                        "type": ".squareup.client.devicesettings.CashManagementSettings",
                        "id": 1,
                        "rule": "optional"
                      },
                      "checkout": {
                        "type": ".squareup.client.devicesettings.CheckoutSettings",
                        "id": 2,
                        "rule": "optional"
                      },
                      "employeeManagement": {
                        "type": ".squareup.client.devicesettings.EmployeeManagementSettings",
                        "id": 3,
                        "rule": "optional"
                      },
                      "openTickets": {
                        "type": ".squareup.client.devicesettings.OpenTicketSettings",
                        "id": 4,
                        "rule": "optional"
                      },
                      "tipping": {
                        "type": ".squareup.client.devicesettings.TippingSettings",
                        "id": 5,
                        "rule": "optional"
                      },
                      "customerManagement": {
                        "type": ".squareup.client.devicesettings.CustomerManagementSettings",
                        "id": 6,
                        "rule": "optional"
                      },
                      "seating": {
                        "type": ".squareup.client.devicesettings.SeatingSettings",
                        "id": 7,
                        "rule": "optional"
                      },
                      "autoGratuity": {
                        "type": ".squareup.client.devicesettings.AutoGratuitySettings",
                        "id": 8,
                        "rule": "optional"
                      },
                      "courseManagement": {
                        "type": ".squareup.client.devicesettings.CourseManagementSettings",
                        "id": 9,
                        "rule": "optional"
                      },
                      "floorPlan": {
                        "type": ".squareup.client.devicesettings.FloorPlanSettings",
                        "id": 10,
                        "rule": "optional"
                      },
                      "hardware": {
                        "type": ".squareup.client.devicesettings.HardwareSettings",
                        "id": 11,
                        "rule": "optional"
                      },
                      "appearance": {
                        "type": ".squareup.client.devicesettings.AppearanceSettings",
                        "id": 12,
                        "rule": "optional"
                      },
                      "orderHub": {
                        "type": ".squareup.client.devicesettings.OrderHubSettings",
                        "id": 13,
                        "rule": "optional"
                      },
                      "kdsFetch": {
                        "type": ".squareup.client.devicesettings.KDSFetchSettings",
                        "id": 14,
                        "rule": "optional"
                      },
                      "kdsUi": {
                        "type": ".squareup.client.devicesettings.KDSUISettings",
                        "id": 15,
                        "rule": "optional"
                      },
                      "ordersMode": {
                        "type": ".squareup.client.devicesettings.OrdersModeSettings",
                        "id": 16,
                        "rule": "optional"
                      },
                      "textCustomer": {
                        "type": ".squareup.client.devicesettings.TextCustomerSettings",
                        "id": 17,
                        "rule": "optional"
                      },
                      "scanToPay": {
                        "type": ".squareup.client.devicesettings.ScanToPaySettings",
                        "id": 18,
                        "rule": "optional"
                      },
                      "fnbKiosk": {
                        "type": ".squareup.client.devicesettings.FNBKioskSettings",
                        "id": 19,
                        "rule": "optional"
                      },
                      "loyalty": {
                        "type": ".squareup.client.devicesettings.Loyalty",
                        "id": 20,
                        "rule": "optional"
                      }
                    }
                  }
                }
              },
              "AppearanceSettings": {
                "fields": {
                  "userInterfaceStyle": {
                    "type": ".squareup.client.devicesettings.AppearanceSettings.UserInterfaceStyle",
                    "id": 1,
                    "rule": "optional",
                    "options": {
                      "default": "DEFAULT"
                    }
                  }
                },
                "nested": {
                  "UserInterfaceStyle": {
                    "values": {
                      "DEFAULT": 0,
                      "LIGHT": 1,
                      "DARK": 2
                    }
                  }
                }
              },
              "AutoGratuitySettings": {
                "fields": {
                  "autoGratuityEnabled": {
                    "type": "bool",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "CashManagementSettings": {
                "fields": {
                  "defaultStartingAmount": {
                    "type": ".squareup.common.Money",
                    "id": 1,
                    "rule": "optional"
                  },
                  "printReport": {
                    "type": "bool",
                    "id": 2,
                    "rule": "optional"
                  },
                  "emailReport": {
                    "type": "bool",
                    "id": 3,
                    "rule": "optional"
                  },
                  "recipientAddress": {
                    "type": "string",
                    "id": 5,
                    "rule": "optional"
                  },
                  "useCashDrawers": {
                    "type": "bool",
                    "id": 6,
                    "rule": "optional"
                  }
                }
              },
              "CheckoutSettings": {
                "fields": {
                  "usePaperSignature": {
                    "type": "bool",
                    "id": 1,
                    "rule": "optional"
                  },
                  "skipSignature": {
                    "type": "bool",
                    "id": 2,
                    "rule": "optional"
                  },
                  "storeAndForwardEnabled": {
                    "type": "bool",
                    "id": 3,
                    "rule": "optional"
                  },
                  "storeAndForwardSingleTransactionLimit": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  },
                  "skipReceiptScreen": {
                    "type": "bool",
                    "id": 5,
                    "rule": "optional"
                  },
                  "forPaperSignatureUseQuickTipReceipt": {
                    "type": "bool",
                    "id": 6,
                    "rule": "optional"
                  },
                  "forPaperSignaturePrintAdditionalAuthSlip": {
                    "type": "bool",
                    "id": 7,
                    "rule": "optional"
                  },
                  "forPaperSignaturePrintItemizedAuthSlip": {
                    "type": "bool",
                    "id": 8,
                    "rule": "optional"
                  },
                  "paperSignatureTipType": {
                    "type": ".squareup.client.devicesettings.CheckoutSettings.PaperSignatureTipType",
                    "id": 9,
                    "rule": "optional"
                  },
                  "skipSignatureAlways": {
                    "type": "bool",
                    "id": 10,
                    "rule": "optional"
                  },
                  "orderTicketNamingType": {
                    "type": ".squareup.client.devicesettings.CheckoutSettings.OrderTicketNamingType",
                    "id": 11,
                    "rule": "optional",
                    "options": {
                      "default": "NAMING_TYPE_UNSET"
                    }
                  },
                  "useBuyerFacingScreen": {
                    "type": "bool",
                    "id": 12,
                    "rule": "optional",
                    "options": {
                      "default": true
                    }
                  },
                  "showBuyerFacingOrderSummary": {
                    "type": "bool",
                    "id": 13,
                    "rule": "optional",
                    "options": {
                      "default": true
                    }
                  }
                },
                "nested": {
                  "PaperSignatureTipType": {
                    "values": {
                      "UNSET": 0,
                      "TRADITIONAL": 1,
                      "QUICK_TIP": 2,
                      "GRATUITY_FREE": 3
                    }
                  },
                  "OrderTicketNamingType": {
                    "values": {
                      "NAMING_TYPE_UNSET": 0,
                      "AUTOMATIC_NUMBERING": 1,
                      "CUSTOM_NAME": 2
                    }
                  }
                }
              },
              "CourseManagementSettings": {
                "fields": {
                  "courseManagementEnabled": {
                    "type": "bool",
                    "id": 1,
                    "rule": "optional"
                  },
                  "expandFiredItemsSectionByDefault": {
                    "type": "bool",
                    "id": 2,
                    "rule": "optional"
                  },
                  "kitchenControlsFire": {
                    "type": "bool",
                    "id": 3,
                    "rule": "optional"
                  }
                }
              },
              "CustomerManagementSettings": {
                "fields": {
                  "collectBeforeCheckout": {
                    "type": "bool",
                    "id": 1,
                    "rule": "optional"
                  },
                  "collectAfterCheckout": {
                    "type": "bool",
                    "id": 2,
                    "rule": "optional"
                  },
                  "useCardOnFile": {
                    "type": "bool",
                    "id": 3,
                    "rule": "optional"
                  },
                  "showSaveCardButtonAfterCheckout": {
                    "type": "bool",
                    "id": 4,
                    "rule": "optional"
                  },
                  "showAddCustomerCartRow": {
                    "type": "bool",
                    "id": 5,
                    "rule": "optional"
                  },
                  "showEmailCollectionScreen": {
                    "type": "bool",
                    "id": 6,
                    "rule": "optional"
                  }
                }
              },
              "EmployeeManagementSettings": {
                "fields": {
                  "trackEmployee": {
                    "type": "bool",
                    "id": 1,
                    "rule": "optional"
                  },
                  "trackTime": {
                    "type": "bool",
                    "id": 2,
                    "rule": "optional"
                  },
                  "inactivityTimeout": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "trackingLevel": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  },
                  "inactivityTimeoutEnum": {
                    "type": ".squareup.client.devicesettings.EmployeeManagementSettings.InactivityTimeout",
                    "id": 6,
                    "rule": "optional"
                  },
                  "trackingLevelEnum": {
                    "type": ".squareup.client.devicesettings.EmployeeManagementSettings.TrackingLevel",
                    "id": 7,
                    "rule": "optional"
                  },
                  "requiresEmployeeLogoutAfterCompletedTransaction": {
                    "type": "bool",
                    "id": 5,
                    "rule": "optional"
                  },
                  "requirePasscodeWhenBackingOutOfBuyerFacingScreen": {
                    "type": "bool",
                    "id": 8,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "InactivityTimeout": {
                    "values": {
                      "UNKNOWN_TIMEOUT": 0,
                      "DO_NOT_TIMEOUT_SCREEN": 1,
                      "TIMEOUT_30_SECONDS": 2,
                      "TIMEOUT_1_MINUTE": 3,
                      "TIMEOUT_5_MINUTE": 4
                    }
                  },
                  "TrackingLevel": {
                    "values": {
                      "UNKNOWN_TRACKING_LEVEL": 0,
                      "RESTRICTED_MODE": 1,
                      "EMPLOYEE_MODE": 2
                    }
                  }
                }
              },
              "FloorPlanSettings": {
                "fields": {
                  "showFloorPlanTimers": {
                    "type": "bool",
                    "id": 1,
                    "rule": "optional"
                  },
                  "useTableInactivityIndicators": {
                    "type": "bool",
                    "id": 2,
                    "rule": "optional"
                  },
                  "tableIndicatorWarningTime": {
                    "type": "uint32",
                    "id": 3,
                    "rule": "optional"
                  },
                  "tableIndicatorAlertTime": {
                    "type": "uint32",
                    "id": 4,
                    "rule": "optional"
                  }
                }
              },
              "HardwareSettings": {
                "fields": {
                  "requireCardReader": {
                    "type": "bool",
                    "id": 1,
                    "rule": "optional"
                  },
                  "requireCashDrawer": {
                    "type": "bool",
                    "id": 2,
                    "rule": "optional"
                  },
                  "requirePrinter": {
                    "type": "bool",
                    "id": 3,
                    "rule": "optional"
                  }
                }
              },
              "KDSFetchSettings": {
                "fields": {
                  "categories": {
                    "type": ".squareup.client.devicesettings.KDSFetchSettings.CategoryConfiguration",
                    "id": 2,
                    "rule": "repeated"
                  },
                  "uncategorizedEnabled": {
                    "type": "bool",
                    "id": 3,
                    "rule": "optional",
                    "options": {
                      "default": true
                    }
                  },
                  "includeFutureCategoriesEnabled": {
                    "type": "bool",
                    "id": 4,
                    "rule": "optional",
                    "options": {
                      "default": true
                    }
                  },
                  "ordersEnabled": {
                    "type": "bool",
                    "id": 5,
                    "rule": "optional",
                    "options": {
                      "default": true
                    }
                  },
                  "displayOrderOnState": {
                    "type": ".squareup.client.devicesettings.KDSFetchSettings.DisplayOrderConfigurationState",
                    "id": 6,
                    "rule": "optional",
                    "options": {
                      "default": "ON_NEW"
                    }
                  },
                  "posEnabled": {
                    "type": "bool",
                    "id": 7,
                    "rule": "optional",
                    "options": {
                      "default": true
                    }
                  },
                  "stationOnPickupBufferSeconds": {
                    "type": "int32",
                    "id": 8,
                    "rule": "optional",
                    "options": {
                      "default": 900
                    }
                  },
                  "posDeviceConfigurations": {
                    "type": ".squareup.client.devicesettings.KDSFetchSettings.POSDeviceConfiguration",
                    "id": 9,
                    "rule": "repeated"
                  },
                  "includeFutureNamedPosEnabled": {
                    "type": "bool",
                    "id": 10,
                    "rule": "optional",
                    "options": {
                      "default": true
                    }
                  },
                  "includeUnnamedPosEnabled": {
                    "type": "bool",
                    "id": 11,
                    "rule": "optional",
                    "options": {
                      "default": true
                    }
                  },
                  "coursingDisplayType": {
                    "type": ".squareup.client.devicesettings.KDSFetchSettings.CoursingDisplayType",
                    "id": 12,
                    "rule": "optional",
                    "options": {
                      "default": "SHOW_HELD_AND_FIRED_COURSES"
                    }
                  },
                  "includeFutureDiningOptionsEnabled": {
                    "type": "bool",
                    "id": 13,
                    "rule": "optional",
                    "options": {
                      "default": true
                    }
                  },
                  "diningOptionConfigurations": {
                    "type": ".squareup.client.devicesettings.KDSFetchSettings.DiningOptionConfiguration",
                    "id": 14,
                    "rule": "repeated"
                  }
                },
                "nested": {
                  "CategoryConfiguration": {
                    "fields": {
                      "catalogObjectToken": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "enabled": {
                        "type": "bool",
                        "id": 2,
                        "rule": "optional"
                      },
                      "isKitchen": {
                        "type": "bool",
                        "id": 3,
                        "rule": "optional"
                      },
                      "displayName": {
                        "type": "string",
                        "id": 4,
                        "rule": "optional"
                      }
                    }
                  },
                  "DisplayOrderConfigurationState": {
                    "values": {
                      "DISPLAY_ORDER_CONFIGURATION_STATE_EVENT_DO_NOT_USE": 0,
                      "ON_NEW": 1,
                      "ON_MARKED_IN_PROGRESS": 2,
                      "ON_PLACED": 3,
                      "ON_PICKUP_WITH_BUFFER": 4
                    }
                  },
                  "POSDeviceConfiguration": {
                    "fields": {
                      "deviceCredentialToken": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "enabled": {
                        "type": "bool",
                        "id": 2,
                        "rule": "optional"
                      }
                    }
                  },
                  "CoursingDisplayType": {
                    "values": {
                      "COURSING_TYPE_DO_NOT_USE": 0,
                      "SHOW_FIRED_COURSES_ONLY": 1,
                      "SHOW_HELD_AND_FIRED_COURSES": 2
                    }
                  },
                  "DiningOptionConfiguration": {
                    "fields": {
                      "catalogObjectToken": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "selected": {
                        "type": "bool",
                        "id": 2,
                        "rule": "optional"
                      },
                      "displayName": {
                        "type": "string",
                        "id": 3,
                        "rule": "optional"
                      }
                    }
                  }
                }
              },
              "KDSUISettings": {
                "fields": {
                  "timerSettings": {
                    "type": ".squareup.client.devicesettings.KDSUISettings.TimerSetting",
                    "id": 1,
                    "rule": "repeated"
                  },
                  "enabledSounds": {
                    "type": ".squareup.client.devicesettings.KDSUISettings.SoundType",
                    "id": 2,
                    "rule": "repeated"
                  },
                  "layout": {
                    "type": ".squareup.client.devicesettings.KDSUISettings.Layout",
                    "id": 3,
                    "rule": "optional"
                  },
                  "textSize": {
                    "type": ".squareup.client.devicesettings.KDSUISettings.TextSize",
                    "id": 4,
                    "rule": "optional",
                    "options": {
                      "default": "MEDIUM"
                    }
                  },
                  "sounds": {
                    "type": ".squareup.client.devicesettings.KDSUISettings.Sounds",
                    "id": 5,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "TimerSetting": {
                    "fields": {
                      "timerEnabled": {
                        "type": "bool",
                        "id": 1,
                        "rule": "optional"
                      },
                      "fireInterval": {
                        "type": "uint32",
                        "id": 2,
                        "rule": "optional"
                      },
                      "color": {
                        "type": ".squareup.client.devicesettings.KDSUISettings.TimerColor",
                        "id": 4,
                        "rule": "optional"
                      }
                    }
                  },
                  "Layout": {
                    "fields": {
                      "layoutType": {
                        "type": ".squareup.client.devicesettings.KDSUISettings.LayoutType",
                        "id": 1,
                        "rule": "optional"
                      },
                      "fixedLayoutRows": {
                        "type": "uint32",
                        "id": 2,
                        "rule": "optional"
                      },
                      "fixedLayoutColumns": {
                        "type": "uint32",
                        "id": 3,
                        "rule": "optional"
                      }
                    }
                  },
                  "Sounds": {
                    "fields": {
                      "enabledSounds": {
                        "type": ".squareup.client.devicesettings.KDSUISettings.SoundType",
                        "id": 1,
                        "rule": "repeated"
                      }
                    }
                  },
                  "TimerColor": {
                    "values": {
                      "TIMER_COLOR_DO_NOT_USE": 0,
                      "YELLOW": 1,
                      "RED": 2
                    }
                  },
                  "LayoutType": {
                    "values": {
                      "LAYOUT_TYPE_DO_NOT_USE": 0,
                      "FIXED": 1,
                      "TILE": 2,
                      "RAIL": 3
                    }
                  },
                  "TextSize": {
                    "values": {
                      "TEXT_SIZE_DO_NOT_USE": 0,
                      "SMALL": 1,
                      "MEDIUM": 2,
                      "LARGE": 3
                    }
                  },
                  "SoundType": {
                    "values": {
                      "SOUND_DO_NOT_USE": 0,
                      "NEW_TICKET": 1
                    }
                  }
                }
              },
              "OpenTicketSettings": {
                "fields": {
                  "openTicketsEnabled": {
                    "type": "bool",
                    "id": 1,
                    "rule": "optional"
                  },
                  "useOpenTicketsMenuAsHomeScreen": {
                    "type": "bool",
                    "id": 2,
                    "rule": "optional"
                  },
                  "usePredefinedTickets": {
                    "type": "bool",
                    "id": 3,
                    "rule": "optional"
                  }
                }
              },
              "OrderHubSettings": {
                "fields": {
                  "useOrderHub": {
                    "type": "bool",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "OrdersModeSettings": {
                "fields": {
                  "ordersModeEnabled": {
                    "type": "bool",
                    "id": 1,
                    "rule": "optional",
                    "options": {
                      "default": false
                    }
                  }
                }
              },
              "SeatingSettings": {
                "fields": {
                  "seatingEnabled": {
                    "type": "bool",
                    "id": 1,
                    "rule": "optional"
                  },
                  "seatAssignmentOption": {
                    "type": ".squareup.client.devicesettings.SeatingSettings.SeatAssignmentOption",
                    "id": 2,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "SeatAssignmentOption": {
                    "values": {
                      "DISABLED": 0,
                      "OPTIONAL": 1,
                      "REQUIRED": 2
                    }
                  }
                }
              },
              "TenderSettings": {
                "fields": {
                  "primaryTender": {
                    "type": ".squareup.client.devicesettings.TenderSettings.Tender",
                    "id": 1,
                    "rule": "repeated"
                  },
                  "secondaryTender": {
                    "type": ".squareup.client.devicesettings.TenderSettings.Tender",
                    "id": 2,
                    "rule": "repeated"
                  },
                  "disabledTender": {
                    "type": ".squareup.client.devicesettings.TenderSettings.Tender",
                    "id": 3,
                    "rule": "repeated"
                  }
                },
                "nested": {
                  "TenderType": {
                    "values": {
                      "UNKNOWN": 0,
                      "CARD": 1,
                      "GIFT_CARD": 2,
                      "CASH": 3,
                      "INVOICE": 4,
                      "CARD_ON_FILE": 5,
                      "E_MONEY": 6,
                      "INSTALLMENTS": 7,
                      "CHECKOUT_LINK": 8,
                      "DEFERRED_PAY": 9,
                      "PUSH": 10,
                      "CHECKOUT_LINK_QR_CODE": 11,
                      "PUSH_PAYPAY": 12,
                      "PUSH_ALIPAY_CN": 13,
                      "HOUSE_ACCOUNTS": 14,
                      "BITCOIN": 15
                    }
                  },
                  "Tender": {
                    "fields": {
                      "tenderType": {
                        "type": ".squareup.client.devicesettings.TenderSettings.TenderType",
                        "id": 1,
                        "rule": "optional"
                      },
                      "legacyOtherTenderTypeId": {
                        "type": "uint32",
                        "id": 2,
                        "rule": "optional"
                      }
                    }
                  }
                }
              },
              "TextCustomerSettings": {
                "fields": {
                  "promptBeforeCheckout": {
                    "type": "bool",
                    "id": 1,
                    "rule": "optional",
                    "options": {
                      "default": false
                    }
                  },
                  "promptWhenNeeded": {
                    "type": "bool",
                    "id": 2,
                    "rule": "optional",
                    "options": {
                      "default": false
                    }
                  }
                }
              },
              "ScanToPaySettings": {
                "fields": {
                  "printQrCodeOnReceipt": {
                    "type": "bool",
                    "id": 1,
                    "rule": "optional",
                    "options": {
                      "default": false
                    }
                  }
                }
              },
              "FNBKioskSettings": {
                "fields": {
                  "allowGiftCards": {
                    "type": "bool",
                    "id": 1,
                    "rule": "optional",
                    "options": {
                      "default": false
                    }
                  },
                  "diningOptions": {
                    "type": ".squareup.client.devicesettings.FNBKioskSettings.FNBKioskDiningOption",
                    "id": 2,
                    "rule": "repeated"
                  }
                },
                "nested": {
                  "FNBKioskDiningOption": {
                    "fields": {
                      "diningOptionId": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "kioskOrdinal": {
                        "type": "int32",
                        "id": 2,
                        "rule": "optional"
                      }
                    }
                  }
                }
              },
              "Loyalty": {
                "fields": {
                  "isEnabled": {
                    "type": "bool",
                    "id": 1,
                    "rule": "optional",
                    "options": {
                      "default": true
                    }
                  },
                  "isDisabledInTransactionFlow": {
                    "type": "bool",
                    "id": 2,
                    "rule": "optional",
                    "options": {
                      "default": false
                    }
                  },
                  "isAlwaysShowDisabled": {
                    "type": "bool",
                    "id": 3,
                    "rule": "optional",
                    "options": {
                      "default": true
                    }
                  },
                  "isStarBackgroundDisabled": {
                    "type": "bool",
                    "id": 4,
                    "rule": "optional",
                    "options": {
                      "default": true
                    }
                  },
                  "isRedeemRewardsInCheckoutDisabled": {
                    "type": "bool",
                    "id": 5,
                    "rule": "optional",
                    "options": {
                      "default": true
                    }
                  },
                  "dismissTimerInterval": {
                    "type": "int32",
                    "id": 6,
                    "rule": "optional",
                    "options": {
                      "default": 60
                    }
                  },
                  "showCheckInScreenAtTransactionStart": {
                    "type": "bool",
                    "id": 7,
                    "rule": "optional",
                    "options": {
                      "default": true
                    }
                  }
                }
              },
              "TippingSettings": {
                "fields": {
                  "tippingEnabled": {
                    "type": "bool",
                    "id": 1,
                    "rule": "optional"
                  },
                  "tippingUseCustomPercentages": {
                    "type": "bool",
                    "id": 2,
                    "rule": "optional"
                  },
                  "tippingPercentageTipAmount": {
                    "type": "uint32",
                    "id": 3,
                    "rule": "repeated"
                  },
                  "tippingUseManualTipEntry": {
                    "type": "bool",
                    "id": 4,
                    "rule": "optional"
                  },
                  "useSeparateTippingScreen": {
                    "type": "bool",
                    "id": 5,
                    "rule": "optional"
                  },
                  "tippingCalculationPhase": {
                    "type": ".squareup.client.devicesettings.TippingSettings.TippingCalculationPhase",
                    "id": 6,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "TippingCalculationPhase": {
                    "values": {
                      "POST_TAX_TIP_CALCULATION": 0,
                      "PRE_TAX_TIP_CALCULATION": 1
                    }
                  }
                }
              },
              "DefaultDeviceProfilesRequest": {
                "fields": {}
              },
              "DefaultDeviceProfilesResponse": {
                "fields": {
                  "pointOfSaleDefault": {
                    "type": ".squareup.client.devicesettings.DeviceProfile.Settings",
                    "id": 1,
                    "rule": "optional"
                  },
                  "retailDefault": {
                    "type": ".squareup.client.devicesettings.DeviceProfile.Settings",
                    "id": 2,
                    "rule": "optional"
                  },
                  "rstQuickServiceDefault": {
                    "type": ".squareup.client.devicesettings.DeviceProfile.Settings",
                    "id": 3,
                    "rule": "optional"
                  },
                  "rstTableServiceDefault": {
                    "type": ".squareup.client.devicesettings.DeviceProfile.Settings",
                    "id": 4,
                    "rule": "optional"
                  },
                  "rstBarLoungeDefault": {
                    "type": ".squareup.client.devicesettings.DeviceProfile.Settings",
                    "id": 5,
                    "rule": "optional"
                  },
                  "kdsDefault": {
                    "type": ".squareup.client.devicesettings.DeviceProfile.Settings",
                    "id": 6,
                    "rule": "optional"
                  },
                  "kdsExpoDefault": {
                    "type": ".squareup.client.devicesettings.DeviceProfile.Settings",
                    "id": 7,
                    "rule": "optional"
                  },
                  "fnbKioskDefault": {
                    "type": ".squareup.client.devicesettings.DeviceProfile.Settings",
                    "id": 8,
                    "rule": "optional"
                  }
                }
              },
              "DefaultDeviceProfileService": {
                "methods": {
                  "DefaultDeviceProfiles": {
                    "requestType": ".squareup.client.devicesettings.DefaultDeviceProfilesRequest",
                    "responseType": ".squareup.client.devicesettings.DefaultDeviceProfilesResponse"
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.client?.nested?.devicesettings?.nested?.DeviceProfile?.nested?.Settings && !$root.nested?.squareup?.nested?.client?.nested?.devicesettings?.nested?.AppearanceSettings && !$root.nested?.squareup?.nested?.client?.nested?.devicesettings?.nested?.AppearanceSettings?.nested?.UserInterfaceStyle && !$root.nested?.squareup?.nested?.client?.nested?.devicesettings?.nested?.AutoGratuitySettings && !$root.nested?.squareup?.nested?.client?.nested?.devicesettings?.nested?.CashManagementSettings && !$root.nested?.squareup?.nested?.client?.nested?.devicesettings?.nested?.CheckoutSettings && !$root.nested?.squareup?.nested?.client?.nested?.devicesettings?.nested?.CheckoutSettings?.nested?.PaperSignatureTipType && !$root.nested?.squareup?.nested?.client?.nested?.devicesettings?.nested?.CheckoutSettings?.nested?.OrderTicketNamingType && !$root.nested?.squareup?.nested?.client?.nested?.devicesettings?.nested?.CourseManagementSettings && !$root.nested?.squareup?.nested?.client?.nested?.devicesettings?.nested?.CustomerManagementSettings && !$root.nested?.squareup?.nested?.client?.nested?.devicesettings?.nested?.EmployeeManagementSettings && !$root.nested?.squareup?.nested?.client?.nested?.devicesettings?.nested?.EmployeeManagementSettings?.nested?.InactivityTimeout && !$root.nested?.squareup?.nested?.client?.nested?.devicesettings?.nested?.EmployeeManagementSettings?.nested?.TrackingLevel && !$root.nested?.squareup?.nested?.client?.nested?.devicesettings?.nested?.FloorPlanSettings && !$root.nested?.squareup?.nested?.client?.nested?.devicesettings?.nested?.HardwareSettings && !$root.nested?.squareup?.nested?.client?.nested?.devicesettings?.nested?.KDSFetchSettings && !$root.nested?.squareup?.nested?.client?.nested?.devicesettings?.nested?.KDSFetchSettings?.nested?.CategoryConfiguration && !$root.nested?.squareup?.nested?.client?.nested?.devicesettings?.nested?.KDSFetchSettings?.nested?.DisplayOrderConfigurationState && !$root.nested?.squareup?.nested?.client?.nested?.devicesettings?.nested?.KDSFetchSettings?.nested?.POSDeviceConfiguration && !$root.nested?.squareup?.nested?.client?.nested?.devicesettings?.nested?.KDSFetchSettings?.nested?.CoursingDisplayType && !$root.nested?.squareup?.nested?.client?.nested?.devicesettings?.nested?.KDSFetchSettings?.nested?.DiningOptionConfiguration && !$root.nested?.squareup?.nested?.client?.nested?.devicesettings?.nested?.KDSUISettings && !$root.nested?.squareup?.nested?.client?.nested?.devicesettings?.nested?.KDSUISettings?.nested?.TimerSetting && !$root.nested?.squareup?.nested?.client?.nested?.devicesettings?.nested?.KDSUISettings?.nested?.Layout && !$root.nested?.squareup?.nested?.client?.nested?.devicesettings?.nested?.KDSUISettings?.nested?.Sounds && !$root.nested?.squareup?.nested?.client?.nested?.devicesettings?.nested?.KDSUISettings?.nested?.TimerColor && !$root.nested?.squareup?.nested?.client?.nested?.devicesettings?.nested?.KDSUISettings?.nested?.LayoutType && !$root.nested?.squareup?.nested?.client?.nested?.devicesettings?.nested?.KDSUISettings?.nested?.TextSize && !$root.nested?.squareup?.nested?.client?.nested?.devicesettings?.nested?.KDSUISettings?.nested?.SoundType && !$root.nested?.squareup?.nested?.client?.nested?.devicesettings?.nested?.OpenTicketSettings && !$root.nested?.squareup?.nested?.client?.nested?.devicesettings?.nested?.OrderHubSettings && !$root.nested?.squareup?.nested?.client?.nested?.devicesettings?.nested?.OrdersModeSettings && !$root.nested?.squareup?.nested?.client?.nested?.devicesettings?.nested?.SeatingSettings && !$root.nested?.squareup?.nested?.client?.nested?.devicesettings?.nested?.SeatingSettings?.nested?.SeatAssignmentOption && !$root.nested?.squareup?.nested?.client?.nested?.devicesettings?.nested?.TenderSettings && !$root.nested?.squareup?.nested?.client?.nested?.devicesettings?.nested?.TenderSettings?.nested?.TenderType && !$root.nested?.squareup?.nested?.client?.nested?.devicesettings?.nested?.TenderSettings?.nested?.Tender && !$root.nested?.squareup?.nested?.client?.nested?.devicesettings?.nested?.TextCustomerSettings && !$root.nested?.squareup?.nested?.client?.nested?.devicesettings?.nested?.ScanToPaySettings && !$root.nested?.squareup?.nested?.client?.nested?.devicesettings?.nested?.FNBKioskSettings && !$root.nested?.squareup?.nested?.client?.nested?.devicesettings?.nested?.FNBKioskSettings?.nested?.FNBKioskDiningOption && !$root.nested?.squareup?.nested?.client?.nested?.devicesettings?.nested?.Loyalty && !$root.nested?.squareup?.nested?.client?.nested?.devicesettings?.nested?.TippingSettings && !$root.nested?.squareup?.nested?.client?.nested?.devicesettings?.nested?.TippingSettings?.nested?.TippingCalculationPhase && !$root.nested?.squareup?.nested?.client?.nested?.devicesettings?.nested?.DefaultDeviceProfilesRequest && !$root.nested?.squareup?.nested?.client?.nested?.devicesettings?.nested?.DefaultDeviceProfilesResponse && !$root.nested?.squareup?.nested?.client?.nested?.devicesettings?.nested?.DefaultDeviceProfileService) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE DeviceProfile @ squareup/client/device_settings/device_profile.proto at 15:1
 */
export const DeviceProfile = {};
/**
 * Every setting that can be set on a device. This is a flattened form (not split out by
 * verticals) so that devices do not have to have special casing for what types of settings they
 * can read from the profile they have. Only the settings that are relevant for the device/vertical
 * will be set, since these will be converted from server protos.
 *
 * SOURCE Settings @ squareup/client/device_settings/device_profile.proto at 23:5
 */
DeviceProfile.Settings = $root.lookupType('squareup.client.devicesettings.DeviceProfile.Settings');
fixType(DeviceProfile.Settings);
Builder.createAndAttachToType(DeviceProfile.Settings);
/**
 * SOURCE AppearanceSettings @ squareup/client/device_settings/device_profile.proto at 70:1
 */
export const AppearanceSettings = $root.lookupType('squareup.client.devicesettings.AppearanceSettings');
fixType(AppearanceSettings);
Builder.createAndAttachToType(AppearanceSettings);
/**
 * SOURCE UserInterfaceStyle @ squareup/client/device_settings/device_profile.proto at 71:5
 */
AppearanceSettings.UserInterfaceStyle = $root.lookupEnum('squareup.client.devicesettings.AppearanceSettings.UserInterfaceStyle').values;
/**
 * SOURCE AutoGratuitySettings @ squareup/client/device_settings/device_profile.proto at 82:1
 */
export const AutoGratuitySettings = $root.lookupType('squareup.client.devicesettings.AutoGratuitySettings');
fixType(AutoGratuitySettings);
Builder.createAndAttachToType(AutoGratuitySettings);
/**
 * SOURCE CashManagementSettings @ squareup/client/device_settings/device_profile.proto at 89:1
 */
export const CashManagementSettings = $root.lookupType('squareup.client.devicesettings.CashManagementSettings');
fixType(CashManagementSettings);
Builder.createAndAttachToType(CashManagementSettings);
/**
 * SOURCE CheckoutSettings @ squareup/client/device_settings/device_profile.proto at 112:1
 */
export const CheckoutSettings = $root.lookupType('squareup.client.devicesettings.CheckoutSettings');
fixType(CheckoutSettings);
Builder.createAndAttachToType(CheckoutSettings);
/**
 * SOURCE PaperSignatureTipType @ squareup/client/device_settings/device_profile.proto at 137:5
 */
CheckoutSettings.PaperSignatureTipType = $root.lookupEnum('squareup.client.devicesettings.CheckoutSettings.PaperSignatureTipType').values;
/**
 * SOURCE OrderTicketNamingType @ squareup/client/device_settings/device_profile.proto at 161:5
 */
CheckoutSettings.OrderTicketNamingType = $root.lookupEnum('squareup.client.devicesettings.CheckoutSettings.OrderTicketNamingType').values;
/**
 * SOURCE CourseManagementSettings @ squareup/client/device_settings/device_profile.proto at 184:1
 */
export const CourseManagementSettings = $root.lookupType('squareup.client.devicesettings.CourseManagementSettings');
fixType(CourseManagementSettings);
Builder.createAndAttachToType(CourseManagementSettings);
/**
 * SOURCE CustomerManagementSettings @ squareup/client/device_settings/device_profile.proto at 195:1
 */
export const CustomerManagementSettings = $root.lookupType('squareup.client.devicesettings.CustomerManagementSettings');
fixType(CustomerManagementSettings);
Builder.createAndAttachToType(CustomerManagementSettings);
/**
 * SOURCE EmployeeManagementSettings @ squareup/client/device_settings/device_profile.proto at 215:1
 */
export const EmployeeManagementSettings = $root.lookupType('squareup.client.devicesettings.EmployeeManagementSettings');
fixType(EmployeeManagementSettings);
Builder.createAndAttachToType(EmployeeManagementSettings);
/**
 * SOURCE InactivityTimeout @ squareup/client/device_settings/device_profile.proto at 228:5
 */
EmployeeManagementSettings.InactivityTimeout = $root.lookupEnum('squareup.client.devicesettings.EmployeeManagementSettings.InactivityTimeout').values;
/**
 * SOURCE TrackingLevel @ squareup/client/device_settings/device_profile.proto at 243:5
 */
EmployeeManagementSettings.TrackingLevel = $root.lookupEnum('squareup.client.devicesettings.EmployeeManagementSettings.TrackingLevel').values;
/**
 * SOURCE FloorPlanSettings @ squareup/client/device_settings/device_profile.proto at 272:1
 */
export const FloorPlanSettings = $root.lookupType('squareup.client.devicesettings.FloorPlanSettings');
fixType(FloorPlanSettings);
Builder.createAndAttachToType(FloorPlanSettings);
/**
 * SOURCE HardwareSettings @ squareup/client/device_settings/device_profile.proto at 286:1
 */
export const HardwareSettings = $root.lookupType('squareup.client.devicesettings.HardwareSettings');
fixType(HardwareSettings);
Builder.createAndAttachToType(HardwareSettings);
/**
 * SOURCE KDSFetchSettings @ squareup/client/device_settings/device_profile.proto at 297:1
 */
export const KDSFetchSettings = $root.lookupType('squareup.client.devicesettings.KDSFetchSettings');
fixType(KDSFetchSettings);
Builder.createAndAttachToType(KDSFetchSettings);
/**
 * SOURCE CategoryConfiguration @ squareup/client/device_settings/device_profile.proto at 332:3
 */
KDSFetchSettings.CategoryConfiguration = $root.lookupType('squareup.client.devicesettings.KDSFetchSettings.CategoryConfiguration');
fixType(KDSFetchSettings.CategoryConfiguration);
Builder.createAndAttachToType(KDSFetchSettings.CategoryConfiguration);
/**
 * SOURCE DisplayOrderConfigurationState @ squareup/client/device_settings/device_profile.proto at 346:3
 */
KDSFetchSettings.DisplayOrderConfigurationState = $root.lookupEnum('squareup.client.devicesettings.KDSFetchSettings.DisplayOrderConfigurationState').values;
/**
 * Represents filtering configuration for one POS client signed in by device code.
 *
 * SOURCE POSDeviceConfiguration @ squareup/client/device_settings/device_profile.proto at 374:3
 */
KDSFetchSettings.POSDeviceConfiguration = $root.lookupType('squareup.client.devicesettings.KDSFetchSettings.POSDeviceConfiguration');
fixType(KDSFetchSettings.POSDeviceConfiguration);
Builder.createAndAttachToType(KDSFetchSettings.POSDeviceConfiguration);
/**
 * SOURCE CoursingDisplayType @ squareup/client/device_settings/device_profile.proto at 392:3
 */
KDSFetchSettings.CoursingDisplayType = $root.lookupEnum('squareup.client.devicesettings.KDSFetchSettings.CoursingDisplayType').values;
/**
 * SOURCE DiningOptionConfiguration @ squareup/client/device_settings/device_profile.proto at 408:3
 */
KDSFetchSettings.DiningOptionConfiguration = $root.lookupType('squareup.client.devicesettings.KDSFetchSettings.DiningOptionConfiguration');
fixType(KDSFetchSettings.DiningOptionConfiguration);
Builder.createAndAttachToType(KDSFetchSettings.DiningOptionConfiguration);
/**
 * SOURCE KDSUISettings @ squareup/client/device_settings/device_profile.proto at 423:1
 */
export const KDSUISettings = $root.lookupType('squareup.client.devicesettings.KDSUISettings');
fixType(KDSUISettings);
Builder.createAndAttachToType(KDSUISettings);
/**
 * SOURCE TimerSetting @ squareup/client/device_settings/device_profile.proto at 440:3
 */
KDSUISettings.TimerSetting = $root.lookupType('squareup.client.devicesettings.KDSUISettings.TimerSetting');
fixType(KDSUISettings.TimerSetting);
Builder.createAndAttachToType(KDSUISettings.TimerSetting);
/**
 * SOURCE Layout @ squareup/client/device_settings/device_profile.proto at 449:3
 */
KDSUISettings.Layout = $root.lookupType('squareup.client.devicesettings.KDSUISettings.Layout');
fixType(KDSUISettings.Layout);
Builder.createAndAttachToType(KDSUISettings.Layout);
/**
 * SOURCE Sounds @ squareup/client/device_settings/device_profile.proto at 455:3
 */
KDSUISettings.Sounds = $root.lookupType('squareup.client.devicesettings.KDSUISettings.Sounds');
fixType(KDSUISettings.Sounds);
Builder.createAndAttachToType(KDSUISettings.Sounds);
/**
 * SOURCE TimerColor @ squareup/client/device_settings/device_profile.proto at 459:3
 */
KDSUISettings.TimerColor = $root.lookupEnum('squareup.client.devicesettings.KDSUISettings.TimerColor').values;
/**
 * SOURCE LayoutType @ squareup/client/device_settings/device_profile.proto at 465:3
 */
KDSUISettings.LayoutType = $root.lookupEnum('squareup.client.devicesettings.KDSUISettings.LayoutType').values;
/**
 * SOURCE TextSize @ squareup/client/device_settings/device_profile.proto at 472:3
 */
KDSUISettings.TextSize = $root.lookupEnum('squareup.client.devicesettings.KDSUISettings.TextSize').values;
/**
 * SOURCE SoundType @ squareup/client/device_settings/device_profile.proto at 479:3
 */
KDSUISettings.SoundType = $root.lookupEnum('squareup.client.devicesettings.KDSUISettings.SoundType').values;
/**
 * SOURCE OpenTicketSettings @ squareup/client/device_settings/device_profile.proto at 485:1
 */
export const OpenTicketSettings = $root.lookupType('squareup.client.devicesettings.OpenTicketSettings');
fixType(OpenTicketSettings);
Builder.createAndAttachToType(OpenTicketSettings);
/**
 * SOURCE OrderHubSettings @ squareup/client/device_settings/device_profile.proto at 496:1
 */
export const OrderHubSettings = $root.lookupType('squareup.client.devicesettings.OrderHubSettings');
fixType(OrderHubSettings);
Builder.createAndAttachToType(OrderHubSettings);
/**
 * SOURCE OrdersModeSettings @ squareup/client/device_settings/device_profile.proto at 501:1
 */
export const OrdersModeSettings = $root.lookupType('squareup.client.devicesettings.OrdersModeSettings');
fixType(OrdersModeSettings);
Builder.createAndAttachToType(OrdersModeSettings);
/**
 * SOURCE SeatingSettings @ squareup/client/device_settings/device_profile.proto at 506:1
 */
export const SeatingSettings = $root.lookupType('squareup.client.devicesettings.SeatingSettings');
fixType(SeatingSettings);
Builder.createAndAttachToType(SeatingSettings);
/**
 * SOURCE SeatAssignmentOption @ squareup/client/device_settings/device_profile.proto at 510:5
 */
SeatingSettings.SeatAssignmentOption = $root.lookupEnum('squareup.client.devicesettings.SeatingSettings.SeatAssignmentOption').values;
/**
 * Currently used by device for Checkout Experience team's Custom Tender Options project, but not
 * yet included in the device profile.
 *
 * SOURCE TenderSettings @ squareup/client/device_settings/device_profile.proto at 522:1
 */
export const TenderSettings = $root.lookupType('squareup.client.devicesettings.TenderSettings');
fixType(TenderSettings);
Builder.createAndAttachToType(TenderSettings);
/**
 * SOURCE TenderType @ squareup/client/device_settings/device_profile.proto at 523:5
 */
TenderSettings.TenderType = $root.lookupEnum('squareup.client.devicesettings.TenderSettings.TenderType').values;
/**
 * SOURCE Tender @ squareup/client/device_settings/device_profile.proto at 564:5
 */
TenderSettings.Tender = $root.lookupType('squareup.client.devicesettings.TenderSettings.Tender');
fixType(TenderSettings.Tender);
Builder.createAndAttachToType(TenderSettings.Tender);
/**
 * SOURCE TextCustomerSettings @ squareup/client/device_settings/device_profile.proto at 575:1
 */
export const TextCustomerSettings = $root.lookupType('squareup.client.devicesettings.TextCustomerSettings');
fixType(TextCustomerSettings);
Builder.createAndAttachToType(TextCustomerSettings);
/**
 * SOURCE ScanToPaySettings @ squareup/client/device_settings/device_profile.proto at 583:1
 */
export const ScanToPaySettings = $root.lookupType('squareup.client.devicesettings.ScanToPaySettings');
fixType(ScanToPaySettings);
Builder.createAndAttachToType(ScanToPaySettings);
/**
 * SOURCE FNBKioskSettings @ squareup/client/device_settings/device_profile.proto at 588:1
 */
export const FNBKioskSettings = $root.lookupType('squareup.client.devicesettings.FNBKioskSettings');
fixType(FNBKioskSettings);
Builder.createAndAttachToType(FNBKioskSettings);
/**
 * SOURCE FNBKioskDiningOption @ squareup/client/device_settings/device_profile.proto at 592:5
 */
FNBKioskSettings.FNBKioskDiningOption = $root.lookupType('squareup.client.devicesettings.FNBKioskSettings.FNBKioskDiningOption');
fixType(FNBKioskSettings.FNBKioskDiningOption);
Builder.createAndAttachToType(FNBKioskSettings.FNBKioskDiningOption);
/**
 * This is directly copied from the Loyalty DPv2 addon, since it is being backported to DPv1 for the F&B Kiosk
 *
 * SOURCE Loyalty @ squareup/client/device_settings/device_profile.proto at 604:1
 */
export const Loyalty = $root.lookupType('squareup.client.devicesettings.Loyalty');
fixType(Loyalty);
Builder.createAndAttachToType(Loyalty);
/**
 * SOURCE TippingSettings @ squareup/client/device_settings/device_profile.proto at 614:1
 */
export const TippingSettings = $root.lookupType('squareup.client.devicesettings.TippingSettings');
fixType(TippingSettings);
Builder.createAndAttachToType(TippingSettings);
/**
 * Equivalent to AccountStatusLookupResponse.TippingPreferences.tipping_calculation_phase
 *
 * SOURCE TippingCalculationPhase @ squareup/client/device_settings/device_profile.proto at 616:5
 */
TippingSettings.TippingCalculationPhase = $root.lookupEnum('squareup.client.devicesettings.TippingSettings.TippingCalculationPhase').values;
/**
 * SOURCE DefaultDeviceProfilesRequest @ squareup/client/device_settings/device_profile.proto at 639:1
 */
export const DefaultDeviceProfilesRequest = $root.lookupType('squareup.client.devicesettings.DefaultDeviceProfilesRequest');
fixType(DefaultDeviceProfilesRequest);
Builder.createAndAttachToType(DefaultDeviceProfilesRequest);
/**
 * SOURCE DefaultDeviceProfilesResponse @ squareup/client/device_settings/device_profile.proto at 642:1
 */
export const DefaultDeviceProfilesResponse = $root.lookupType('squareup.client.devicesettings.DefaultDeviceProfilesResponse');
fixType(DefaultDeviceProfilesResponse);
Builder.createAndAttachToType(DefaultDeviceProfilesResponse);
/**
 * SOURCE DefaultDeviceProfileService @ squareup/client/device_settings/device_profile.proto at 673:1
 */
export const DefaultDeviceProfileService = $root.lookupService('squareup.client.devicesettings.DefaultDeviceProfileService');